import { vendorPreserve } from "@pages/ManualDocumentV2/forms/_shared/preserve";
import { ComplianceDocumentType } from "@utils/documentSeriesEnum";
import { defineForm, MANUAL_DOC_ENDPOINTS } from "../../../../core";
import { verifactuCorrectiveInvoiceSchema } from "./schema";
import { RectificationReason } from "@pages/ManualDocumentV2/invoice/RectificationReason";

export const verifactuCorrectiveInvoiceConfig = defineForm({
  id: "verifactu_corrective_invoice",
  createEndpoint: MANUAL_DOC_ENDPOINTS.VERIFACTU_CORRECTIVE_INVOICE,
  permission: "ManualDocumentsIN_Write",
  seriesPermission: "ManualDocumentsSeries_Read",
  documentClass: "Invoice",
  accountClass: "AccountReceivable",
  taxRatesChannel: "VeriFactu",
  invoiceType: "correctiveInvoice",
  complianceType: ComplianceDocumentType.CorrectiveInvoice,
  requiresLegalRep: true,
  titleKey: "corrective_invoice",
  complianceStandardKey: "verifactu",
  schema: verifactuCorrectiveInvoiceSchema,
  preserveOnReset: vendorPreserve,
  sections: {
    customer: { hiddenFields: ["customerCompanyAddress"] },
    document: {
      extraFields: [
        {
          id: "rectificationReason",
          render: ({ translate }) => <RectificationReason {...{ translate }} />,
        },
      ],
    },
  },
  hiddenSections: ["recurring"],
  omitFromPayload: ["customerCompanyAddress", "RecurringDocument"],
});
